import { render, staticRenderFns } from "./barchart.vue?vue&type=template&id=681a9fe6&scoped=true"
import script from "./barchart.vue?vue&type=script&lang=js"
export * from "./barchart.vue?vue&type=script&lang=js"
import style0 from "./barchart.vue?vue&type=style&index=0&lang=css"
import style1 from "./barchart.vue?vue&type=style&index=1&id=681a9fe6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a9fe6",
  null
  
)

export default component.exports